import React, { useEffect, useState } from 'react';

const ENV_LABEL = {
  development: 'Dev',
  demo: 'Demo',
  production: 'Prod',
  test: 'Test',
  local: 'Local',
};

/**
 * Ambient release chip for the portal sidebar (display-only, not clickable).
 * Public GET /api/v1/version.
 */
export function VersionBadge() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const base = process.env.REACT_APP_BACKEND_URL || '';
        const res = await fetch(`${base}/api/v1/version`);
        if (!res.ok) {
          if (!cancelled) setInfo({ failed: true });
          return;
        }
        const json = await res.json();
        if (!cancelled) setInfo(json);
      } catch {
        if (!cancelled) setInfo({ failed: true });
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (info?.failed) {
    return (
      <p className="px-1 text-[10px] text-muted-foreground" data-testid="version-badge-unavailable">
        Version unavailable
      </p>
    );
  }

  if (!info?.version) {
    return (
      <p className="px-1 text-[10px] text-muted-foreground" data-testid="version-badge-loading">
        Version …
      </p>
    );
  }

  const envKey = (info.environment || '').toLowerCase();
  const envShort = ENV_LABEL[envKey] || info.environment;

  return (
    <div
      className="flex flex-wrap items-center gap-1.5 px-1 text-[10px] text-muted-foreground"
      data-testid="version-badge"
      title={`Build ${info.build_number || '—'} · ${info.git_commit_short || '—'}`}
    >
      <span className="font-medium tabular-nums text-foreground/70" data-testid="version-badge-version">
        v{info.version}
      </span>
      <span className="text-muted-foreground/50" aria-hidden>
        ·
      </span>
      <span
        className="rounded bg-secondary px-1.5 py-0.5 font-semibold uppercase tracking-wide text-foreground/60"
        data-testid="version-badge-environment"
      >
        {envShort}
      </span>
    </div>
  );
}

export default VersionBadge;
